import styled from 'styled-components'

export const SectionContact = styled.div`
  margin-top: 32px;

  h2 {
    text-align: center;
  }
`
export const RedeSociais = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  li {
    margin: 16px;
  }
`
